export default __webpack_public_path__ + "static/media/AurelPack_background.2b9074d4.png";